import axios from "@/utils/axios";
import type { Notification } from "./type";

export const getNewsList = async () => {
  const response = await axios.post("/api/dashboard/news/get_list");
  return response.data.news;
};

export const getNotificationList = async () => {
  const response = await axios.post<{ notifications: Notification[] }>(
    "/api/dashboard/notification/get_list"
  );
  return response.data.notifications;
};

export const getAttendanceStatistics = async (params: {
  from: string;
  to: string;
}) => {
  const response = await axios.post("/api/member/attendance/get_statistics", {
    ...params,
  });
  return response.data.data;
};
